module.exports = __webpack_public_path__ + "img/btn01.04be6551.svg";